<div class="container mx-auto px-4 pb-6 flex flex-col gap-6">
  @for(question of formQuestions.controls; track $index) {
  <app-question
    [question]="question.controls.question.value"
    [popupInfo]="question.controls.info.value"
    [local]="true">
    @if(question.controls.answerType.value === typeResponse.dropdown) {

    <div class="flex flex-col">
      <p-dropdown
        [options]="valueDropdownQuestion"
        variant="outlined"
        optionLabel="label"
        optionValue="value"
        [placeholder]="question.controls.placeholder.value"
        [name]="typeResponse.dropdown + $index"
        [id]="typeResponse.dropdown + $index"
        [formControl]="question.controls.answer"></p-dropdown>
      <small
        class="p-error"
        *ngIf="
          question.controls.answer?.touched &&
          question.controls.answer?.invalid &&
          (question.controls.answer?.errors)!['required']
        "
        >{{ resource.error.duration }}
      </small>
    </div>

    } @else if(question.controls.answerType.value === typeResponse.string) {
    <div>
      <input
        pInputText
        [placeholder]="question.controls.placeholder.value"
        [name]="typeResponse.string + $index"
        [formControl]="question.controls.answer"
        [id]="typeResponse.string + $index" />
      <small
        class="p-error"
        *ngIf="
          question.controls.answer?.touched &&
          question.controls.answer?.invalid &&
          (question.controls.answer?.errors)!['pattern']
        "
        >{{ resource.error.emailformat }}</small
      >
      <div *ngIf="IsAgeValidationEnabled(question.controls.questionType.value)">
        <small class="p-error" *ngIf="!isEligible">{{ resource.error.notEligibleHE }}</small>
      </div>
    </div>

    } @if(question.controls.answerType.value === typeResponse.boolean) {
    <div class="flex flex-col md:flex-row tems-center gap-4">
      <div
        class="clickable-card flex-1 mb-4 justify-center w-full text-center items-center cursor-pointer py-2"
        (click)="question.controls.answer.setValue(true)"
        (keydown)="question.controls.answer.setValue(true)"
        [ngClass]="question.controls.answer.value ? 'active' : 'inactive'"
        [id]="typeResponse.boolean + $index + 'true'">
        <span>{{ question.controls.action1.value }}</span>
      </div>

      <div
        class="clickable-card flex-1 mb-4 justify-center w-full text-center items-center cursor-pointer py-2"
        (click)="question.controls.answer.setValue(false)"
        (keydown)="question.controls.answer.setValue(false)"
        [id]="typeResponse.boolean + $index + 'false'"
        [ngClass]="question.controls.answer.value === false ? 'active' : 'inactive'">
        <span>{{ question.controls.action2.value }}</span>
      </div>
    </div>

    }
  </app-question>
  }

  <button
    pButton
    type="button"
    *ngIf="displayButton"
    [disabled]="!formQuestions.valid"
    class="button-NS hover:button-NS focus:button-NS active:button-NS w-full"
    [label]="resource.nextstep.keepGoing"
    icon="pi pi-arrow-right"
    iconPos="right"
    (click)="switchStep()"></button>
</div>

<app-error-popup
  [show]="displayError"
  (cancel)="displayError = false"
  [title]="resource.error.oups"
  [text]="resource.error.api"></app-error-popup>

<div class="container mx-auto h-28 md:h-40">
  <app-footer class="footer"></app-footer>
</div>
<app-web-callback></app-web-callback>
